__turbopack_context__.v({
  "time": "TimeRange-module-scss-module__LuYCAG__time",
  "timeRange": "TimeRange-module-scss-module__LuYCAG__timeRange",
});
